/**
 * @description
 * Capitalizes a sentence
 * @param {String} text Text to be parsed
 */
const capitalize = (text: string): string => {
  // Capitalizes the first letter of each word in the string
  // and lowercases the rest of the letters
  const words = text.split(' ');
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase(),
  );
  return capitalizedWords.join(' ');
};

export default capitalize;
